import { setAuthFailureHandler } from './api';

class AuthService {
  constructor() {
    this.isAuthenticated = false;
    this.user = null;
    this.token = null;
    
    // 初始化时检查本地存储的认证状态
    this.checkAuthStatus();
    
    // 设置认证失败处理函数
    this.setupAuthFailureHandler();
  }

  // 检查本地存储的认证状态
  checkAuthStatus() {
    try {
      const authStorage = localStorage.getItem('auth-storage');
      if (authStorage) {
        const authData = JSON.parse(authStorage);
        this.token = authData.state?.token;
        this.user = authData.state?.user;
        this.isAuthenticated = !!this.token;
      }
    } catch (error) {
      console.error('[AuthService] 检查认证状态失败:', error);
      this.clearAuth();
    }
  }

  // 设置认证失败处理函数
  setupAuthFailureHandler() {
    setAuthFailureHandler(() => {
      this.handleAuthFailure();
    });
  }

  // 处理认证失败
  handleAuthFailure() {
    console.log('[AuthService] 处理认证失败');
    
    // 清除认证状态
    this.clearAuth();
    
    // 跳转到登录页面
    this.redirectToLogin();
  }

  // 清除认证信息
  clearAuth() {
    this.isAuthenticated = false;
    this.user = null;
    this.token = null;
    
    // 清除本地存储
    localStorage.removeItem('auth-storage');
    localStorage.removeItem('user');
    
    console.log('[AuthService] 认证信息已清除');
  }

  // 跳转到登录页面
  redirectToLogin() {
    const currentPath = window.location.pathname;
    
    // 如果当前不在登录页面，则跳转
    if (currentPath !== '/login') {
      // 保存当前路径，登录成功后可以跳转回来
      const returnUrl = currentPath !== '/' ? currentPath : '';
      
      if (returnUrl) {
        window.location.href = `/login?returnUrl=${encodeURIComponent(returnUrl)}`;
      } else {
        window.location.href = '/login';
      }
      
      console.log('[AuthService] 跳转到登录页面，返回路径:', returnUrl);
    }
  }

  // 设置认证信息
  setAuth(token, user) {
    this.token = token;
    this.user = user;
    this.isAuthenticated = true;
    
    console.log('[AuthService] 认证信息已设置');
  }

  // 获取认证状态
  getAuthStatus() {
    return {
      isAuthenticated: this.isAuthenticated,
      user: this.user,
      token: this.token
    };
  }

  // 检查token是否过期
  isTokenExpired() {
    if (!this.token) return true;
    
    try {
      const payload = JSON.parse(atob(this.token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      
      return payload.exp < currentTime;
    } catch (error) {
      console.error('[AuthService] 检查token过期失败:', error);
      return true;
    }
  }

  // 刷新认证状态
  refreshAuthStatus() {
    this.checkAuthStatus();
    
    // 如果token过期，自动清除认证状态
    if (this.isAuthenticated && this.isTokenExpired()) {
      console.log('[AuthService] Token已过期，自动清除认证状态');
      this.clearAuth();
    }
  }
}

// 创建单例实例
const authService = new AuthService();

export default authService;
